import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Clock } from "lucide-react";
import { downloadAPK } from "../../Helpers/DownloadAPK";
import { GET_ALL_JACKPOT_GAME } from "../../service/admin.service";
import { GiNetworkBars } from "react-icons/gi";

/* ===== Skeleton Tile ===== */
const ResultSkeleton = () => (
  <div className="tw-bg-white tw-p-4 tw-text-center tw-animate-pulse">
    <div className="tw-flex tw-justify-center tw-mb-2">
      <div className="tw-h-3 tw-w-16 tw-bg-gray-200 tw-rounded" />
    </div>
    <div className="tw-h-8 tw-w-20 tw-mx-auto tw-bg-gray-200 tw-rounded" />
  </div>
);

const StartLine = () => {
  const [getData, setgetData] = useState([]);
  const [AppUrl, setAppUrl] = useState("");
  const [loading, setLoading] = useState(true);

  const getResponseData = async () => {
    setLoading(true);
    try {
      const res = await GET_ALL_JACKPOT_GAME();
      if (res.status) {
        setgetData(res.data || []);
        setAppUrl(res.appInfo);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getResponseData();
  }, []);

  const showData = (data = []) => {
    const weekday = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];

    if (!data.length) return null;

    for (const item of data) {
      if (
        weekday
          .map((d) => d.toLowerCase())
          .includes(item.gameDay?.toLowerCase())
      ) {
        return item;
      }
    }
    return null;
  };

  const downloadFile = async () => {
    await downloadAPK();
  };

  return (
    <div className="tw-py-12 tw-px-4 md:tw-px-8 lg:tw-px-12">
      <div className="tw-max-w-7xl tw-mx-auto">
        {/* Header */}
        <div className="tw-mb-8">
          <h2 className="tw-text-xl md:tw-text-2xl tw-font-bold tw-text-gray-900 tw-mb-2">
            Jackpot Results
          </h2>
          <p className="tw-text-gray-600 tw-text-sm">Updated Every Hour</p>
        </div>

        {/* Results Grid */}
        <div className="tw-bg-white tw-rounded-2xl tw-shadow-sm tw-overflow-hidden">
          <div className="tw-grid tw-grid-cols-2 md:tw-grid-cols-4 tw-gap-px tw-bg-gray-200">
            {loading
              ? Array.from({ length: 8 }).map((_, i) => (
                  <ResultSkeleton key={i} />
                ))
              : getData.map((data, index) => {
                  const gameData = showData(data?.gameDetails);

                  return (
                    <div
                      key={index}
                      className="tw-bg-white tw-p-4 tw-text-center hover:tw-bg-gray-50 tw-transition-colors"
                    >
                      {/* Time */}
                      <div className="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-text-gray-500 tw-text-xs tw-mb-2">
                        <Clock className="tw-w-3 tw-h-3" />
                        <span>{data.providerName || "--"}</span>
                      </div>

                      {/* Result */}
                      <div className="tw-text-2xl md:tw-text-3xl tw-font-bold tw-text-[#1e6ebe]">
                        {data.providerResult || "--"}
                      </div>
                    </div>
                  );
                })}
          </div>
        </div>

        {/* View Chart Button */}
        <div className="tw-mt-6">
          <button className="tw-w-full tw-bg-[#1e6ebe] tw-text-white tw-py-4 tw-rounded-2xl tw-font-semibold tw-text-lg tw-flex tw-items-center tw-justify-center tw-gap-2 tw-shadow-lg hover:tw-bg-blue-700 hover:tw-scale-[1.02] tw-transition-all">
            <GiNetworkBars className="tw-w-5 tw-h-5" />
            <Link to="/charts">View Jackpot Chart</Link>
          </button>
        </div>

        {/* Alternative: If you want individual links to charts */}
        {/* Uncomment this section if needed */}
        {/*
        <div className="tw-mt-8 tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-4">
          {getData?.map((data, index) => {
            const gameData = showData(data?.gameDetails);
            const isOpen = gameData?.message !== "Close for today";

            return (
              <Link
                key={index}
                to={`/starline/${data?.providerName.toLowerCase().replace(/\s+/g, "")}`}
                state={{ title: data?.providerName, id: data._id }}
                className="tw-bg-white tw-rounded-xl tw-p-4 tw-shadow-sm hover:tw-shadow-md tw-transition-all tw-no-underline tw-border tw-border-gray-200"
              >
                <div className="tw-flex tw-items-center tw-justify-between tw-mb-3">
                  <h3 className="tw-font-bold tw-text-gray-900">
                    {data.providerName.toUpperCase()}
                  </h3>
                  <span
                    className={`tw-px-3 tw-py-1 tw-rounded-full tw-text-xs tw-font-semibold ${
                      isOpen
                        ? "tw-bg-green-100 tw-text-green-600"
                        : "tw-bg-red-100 tw-text-red-600"
                    }`}
                  >
                    {isOpen ? "Open" : "Closed"}
                  </span>
                </div>
                
                <div className="tw-text-3xl tw-font-bold tw-text-teal-600 tw-mb-2">
                  {data.providerResult}
                </div>
                
                <div className="tw-flex tw-items-center tw-justify-between tw-text-xs tw-text-gray-600">
                  <span>Open: {gameData?.OBT}</span>
                  <span>Close: {gameData?.CBT}</span>
                </div>
              </Link>
            );
          })}
        </div>
        */}
      </div>
    </div>
  );
};

export default StartLine;
